import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { doc, getDoc } from "firebase/firestore";
import { db } from '../../firebase/firebase'; 

export interface ProvinceCounts {
  [provinceName: string]: number;
}

const fetchProvinceCountsFromFirebase = async (): Promise<ProvinceCounts> => {
  const countDocRef = doc(db, "applicant_count", "provincial");
  const docSnap = await getDoc(countDocRef);

  if (docSnap.exists()) {
    return docSnap.data() as ProvinceCounts;
  } else {
    console.warn("Province counts document not found!");
    return {};
  }
};

export const useProvinceCountsFromFirebase = (): UseQueryResult<ProvinceCounts, Error> => {
  return useQuery({
    queryKey: ["provinceCountsFromFirebase"],
    queryFn: fetchProvinceCountsFromFirebase,
    staleTime: 1000 * 60 * 15,
  });
};